import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useCallback, useMemo, } from 'react';
import { FormControl, FormHelperText, styled } from '@mui/material';
import { preventDefault } from 'shared/hooks/utils';
const FormControlWithValidation = styled(FormControl, {
    shouldForwardProp: (prop) => prop !== 'warning',
})(({ theme, warning }) => ({
    '& .MuiOutlinedInput-root': {
        backgroundColor: 'transparent',
    },
    '& .MuiFormLabel-root': {
        color: warning ? theme.palette.warning.main : undefined,
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: warning ? theme.palette.warning.main : undefined,
    },
    '& .MuiFormHelperText-root': {
        color: warning ? theme.palette.warning.main : undefined,
    },
    '& .MuiInputAdornment': {
        color: warning ? theme.palette.warning.main : undefined,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: warning ? theme.palette.warning.main : undefined,
    },
}));
function ControlWithoutLabelImpl(props, ref) {
    const { field, value, onChange, validation_result, validation_warnings_result, onComplete, } = props;
    const has_warning = useMemo(() => validation_result == null && validation_warnings_result != null, [validation_result, validation_warnings_result]);
    const has_error = useMemo(() => validation_result != null, [validation_result]);
    const is_validation_failed = useMemo(() => validation_result != null || validation_warnings_result != null, [validation_result, validation_warnings_result]);
    const _onComplete = useCallback((e) => {
        if (e.key === 'Enter') {
            preventDefault(e);
            onComplete?.();
        }
    }, [onComplete]);
    return (_jsxs(FormControlWithValidation, { fullWidth: true, error: has_error, warning: has_warning, ref: ref, children: [field({
                value,
                onChange,
                onComplete: onComplete != null ? _onComplete : undefined,
            }), is_validation_failed && (_jsx(FormHelperText, { children: _jsx(_Fragment, { children: validation_result ?? validation_warnings_result }) }))] }));
}
export const ControlWithoutLabel = memo(forwardRef(ControlWithoutLabelImpl));
